var browse_bar_more_links = (function( $ ) {

	var $browse_bar;
	var anim_speed = 400;

	var _init = function() {
		$browse_bar = $( '#browse-bar' );

		var $expand_link = $browse_bar.find( 'a#expand-browse-bar-link' );

		$expand_link.on( 'click', function( e ) {
			e.preventDefault();
			_toggle_links();
		} );
	};

	var _toggle_links = function() {
		if ( $browse_bar.hasClass( 'animating' ) ) {
			return;
		}

		$browse_bar.addClass( 'animating' );

		if ( $browse_bar.hasClass( 'open' ) ) {
			_close_browse_bar();
		} else {
			_open_browse_bar();
		}

		setTimeout( function() {
			$browse_bar.removeClass( 'animating' );
		}, anim_speed );
	}

	var _close_browse_bar = function() {
		$browse_bar.removeClass( 'open' );
		$browse_bar.find( 'nav#browse-bar-nav' ).slideUp( anim_speed );
	}

	var _open_browse_bar = function() {
		$browse_bar.addClass( 'open' );
		$browse_bar.find( 'nav#browse-bar-nav' ).slideDown( anim_speed );
	}

	if ( $( '#browse-bar' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

})( jQuery );

module.exports = browse_bar_more_links;
